
export const useIsVendorOnSale = (isVendor:boolean, isOnSale:boolean): boolean => { 
    return isVendor && isOnSale;
};